export enum TransactionType {
    palleting = 'palleting',
    repalleting = 'repalleting',
    repacking = 'repacking',
    reprocessing = 'reprocessing',
    dispatch = 'dispatch',
    unregistered = 'unregistered',
    transfer = 'transfer',
}